import styled from 'styled-components'

import { PairMetricsMarket } from '@root/entities/pair/ui'

import { TradingPairMetricsTable } from './trading-pair-metrics-table'

import type { MetricsTheme } from './constants'
import type { PairModel } from '@root/entities/pair'

type PairMetricsProps = {
  pair: PairModel
  metricsTheme?: MetricsTheme
}

export const TradingPairMetricsPanel: React.FC<PairMetricsProps> = ({
  pair,
  metricsTheme = 'bright',
}) => {
  return (
    <Root>
      <PairMetricsMarket pair={pair} />
      <TradingPairMetricsTable pair={pair} metricsTheme={metricsTheme} />
    </Root>
  )
}

const Root = styled.div`
  background: var(--appearance-1);
  padding-inline: 14px;
  padding-block: 10px 10px;

  display: grid;
  gap: 10px;
`
